import axios from 'axios';
import React,  { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component-with-filter';
import { ListInsideTable, TruncatedSpan } from '../../styled/Table';
import { FormSearch } from '../components/Form';

const parseFromJson = (json) => {
    if (json) {
        return Object.keys(json).map(key => {
            const product = json[key];
            
            return {
                value: product,
                key: key // Use the original key as a property
            };
        });
    }

    return  []
}
    
const columns = [
    {
        name: 'Client Id',
        selector: row => row.kata_client_id,
        sortable: true,
        verticalAlign: 'top'
    },
    {
        name: 'Client Name',
        sortable: true,
        selector: row => row.client_name,
    },
    {
        name: 'Whatsapp number',
        sortable: true,
        selector: row => row.whatsapp_number,
    },
    {
        name: 'Prompt',
        sortable: true,
        selector: row => row.prompt,
        cell: (row) => (
            <TruncatedSpan>
                {row.prompt.length > 400 ? `${row.prompt.substr(0, 400)}...` : row.prompt}
            </TruncatedSpan>
        )
    },
    {
        name: 'User Data',
        sortable: true,
        selector: row => row.user_data,
        cell: (row) => (
            <>
                {row.user_data.length > 0 &&
                <ListInsideTable>
                    {row.user_data.map((user, idx) => idx < 8 && (
                        <li key={idx}>({user.key}) : {user.value}</li>
                    ))}
                    {row.user_data.length > 8 && <li>....</li>}
                </ListInsideTable>}
            </>
        ),
    },
];

const TableData = ({
    onSelect = () => console.log('on select')
}) => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState('');

    const filteredData = data.filter(item =>
        Object.values(item).some(value =>
          value && value.toString().toLowerCase().includes(filterText.toLowerCase())
        )
      );

    const loadPrompt = async () => {
        axios.get(process.env.REACT_APP_BASE_URL)
        .then(response => {
            console.log(response.data);
            setData(response.data.map((item) => ({
                ...item,
                product_data: item.product_data && 
                    item.product_data !== "" && 
                    item.product_data !== "undefined" ? 
                        parseFromJson(JSON.parse(item.product_data)) 
                    : 
                        [],
                user_data: 
                    item.user_data && 
                    item.user_data !== "" && 
                    item.user_data !== "undefined" ? 
                        parseFromJson(JSON.parse(item.user_data)) 
                    : 
                        []
            })));
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    };

    useEffect(() => {
        loadPrompt()
    }, [])

    return (
        <>
            <FormSearch
                type="text"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
                placeholder="Search..."
            />
            <DataTable
                columns={columns}
                data={filteredData}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30]}
                highlightOnHover
                responsive
                onRowDoubleClicked={row => onSelect(row)}
            />
        </>
    );
};

export default TableData